module.exports = __webpack_public_path__ + "img/Honigloeffel-v2-700.af639dfc.png";